import React, { useContext } from 'react';
import LocalizationContext from '../../../contexts/Localizations';
import Carousel from '../../Carousel';
import { LiveEventsCarouselProps } from '../type';
import './liveEvents.scss';

const LiveEventsCarousel = ({ events, liveNowLabel }: LiveEventsCarouselProps) => {
  const slickSettings = {
    vertical: false,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    speed: 500,
    infinite: true,
    responsive: [],
  };

  const { locale } = useContext(LocalizationContext);

  const isFrench = locale === 'fr-fr';

  return (
    <div className="live-events-carousel">
      <Carousel slickConfig={slickSettings}>
        {events.map((event) => {
          const raceName = isFrench ? event?.racePicker?.nameFra : event?.racePicker?.nameEng;
          const eventCategoryName = isFrench ? event?.racePicker?.events[0]?.nameFra
            : event?.racePicker?.events[0]?.nameEng;

          return (
            <div className="live-events-carousel__item">
              <div className="live-events-carousel__item__live">{liveNowLabel}</div>
              <div className="live-events-carousel__item__name">{raceName}</div>
              <div className="live-events-carousel__item__status">{eventCategoryName}</div>
            </div>
          );
        })}
      </Carousel>
    </div>
  );
};

export default LiveEventsCarousel;
